import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  FormArray,
} from '@angular/forms';

export function minArrayLength(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formArray = control as FormArray;

    if (!formArray || !Array.isArray(formArray.controls)) {
      return null;
    }

    return formArray.length >= min
      ? null
      : { minArrayLength: { required: min, actual: formArray.length } };
  };
}
